var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrap",style:({ width: _vm.width, height: _vm.height })},[_c(_vm.pascalCaseIcon,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }